import abcjs from "abcjs";

function randomSnareAndBassBeat(): string {

    let remainingMeasures = 4;

    let result = '';

    while (remainingMeasures > 0){
        const thisMeasure = Math.floor(Math.random()*remainingMeasures) + 1;
        remainingMeasures -= thisMeasure;

        const roll = Math.random()
        if (roll < 0.6) {
            result += `F${thisMeasure}`;
        } else if (roll < 0.7) {
            result += `[F${thisMeasure}c${thisMeasure}]`;
        } else if (roll < 0.95) {
            result += `c${thisMeasure}`;
        } else {
            result += `z${thisMeasure}`;
        }
    }
    return result;
}

function randomBar() {
    const result = `ngngngng ngngngng ngngngng ngngngng & ${randomSnareAndBassBeat()} ${randomSnareAndBassBeat()} ${randomSnareAndBassBeat()} ${randomSnareAndBassBeat()}`;
    console.log(result);
    return result;
}

function genRandomDrum(): string {
    return `
X: 1
M: 4/4
L: 1/16
U:n=!style=x!
K:perc
V:ALL
${randomBar()} |`;

}

abcjs.renderAbc("paper", genRandomDrum());
